import { jsx } from 'react/jsx-runtime';
import '../IndexLayoutOld/index.js';
import { IndexLayoutLoading as IndexLayoutLoading$1 } from '../IndexLayoutOld/IndexLayoutLoading.js';

const IndexLayoutLoading = ({ variant, }) => jsx(IndexLayoutLoading$1, { variant: variant });

export { IndexLayoutLoading };
